<template>
  <validation-observer
    vid="stepIntroForm"
    ref="stepIntroForm"
    tag="div"
    novalidate
  >
    <vvs-control-wrapper label="1. Giriş Bilgileri"></vvs-control-wrapper>
    <vvs-input
      name="Ad Soyad"
      label="Ad Soyad"
      placeholder="Adınız Soyadınız"
      validate="withoutEmoji|alpha_spaces|min:3|max:255"
      maxlength="255"
      v-model="step.fullname"
      normal-label
    ></vvs-input>

    <vvs-input
      type="email"
      name="E-Posta"
      label="E-posta"
      placeholder="Vivense'de kullanacağınız e-posta adresini girin."
      validate="required|email|withoutEmoji|uniqueCarrierApplicationemail|uniqueEmail"
      validate-mode="lazy"
      v-model="step.email"
      normal-label
    ></vvs-input>

    <vvs-input
      type="tel"
      name="Telefon"
      label="Telefon"
      placeholder="0(___) ___ __ __"
      mask="0(###) ### ## ##"
      validate="required|min:16"
      validate-mode="lazy"
      v-model="step.phoneNumber"
      normal-label
    ></vvs-input>

    <vvs-textarea
      name="Firma Adı"
      label="Firma Adı"
      placeholder="Vergi levhasında bulunan ticaret ünvanını girin. Şahıs şirketi iseniz adınızı ve soyadınızı yazın."
      validate="required|withoutEmoji|min:2"
      maxlength="150"
      v-model="step.companyName"
      normal-label
      auto-resize
    ></vvs-textarea>
  </validation-observer>
</template>

<script>
import stepsMixin from './../steps.mixin';

export default {
  name: 'StepIntro',
  mixins: [stepsMixin],
};
</script>
